<script setup lang="ts">
import type { Media } from "@/models"
import { useTranslation } from "@/composables"
import { MediaType } from "@/models"

interface MediaTileProps {
  media: Media
}

defineProps<MediaTileProps>()

const { t } = useTranslation()
</script>

<template>
  <div class="gpx-media-tile rounded-lg">
    <img
      :src="media?.getThumbnailUrl()"
      :alt="`Thumbnail for media ${media.title ?? media.fileName}`"
      class="gpx-media-tile-thumbnail rounded-sm"
    >
    <div class="gpx-media-tile-details">
      <h5 class="text-lg line-clamp-1 text-ellipsis" :title="media.title || media.fileName">
        {{ media.title || media.fileName }}
      </h5>
      <p v-if="media.type" class="capitalize text-sm text-gray-600 font-montserrat font-medium">
        {{ media.type === MediaType.Vid ? t("video") : t("photo") }}
      </p>
      <span v-if="media.uploadedBy" data-test="uploaded_by">{{ t('uploaded_by_name', { name: media.uploadedBy }) }}</span>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@reference "../../assets/styles.css";

.gpx-media-tile {
  display: flex;
  gap: 1rem;
  padding: 0.75rem;

  @apply border border-gray-300;
}

.gpx-media-tile-details h5 {
  word-break: break-word;

  @apply font-montserrat text-gray-900;
}

.gpx-media-tile-details span {
  @apply font-light text-gray-700 text-sm;
}

.gpx-media-tile-thumbnail {
  height: 5rem;
  aspect-ratio: 1;
  object-fit: cover;

  @apply shadow-lg;
}
</style>
